import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

const initialState = {
  //The logged in customer ({ firstName, lastName, email, phone, business }), or null
  profile: null,
  //False until the saved login (if any) has been checked
  hasChecked: false,
};

const setProfile = (state, action) => (
  updateObject(state, {
    profile: action.profile,
  })
);

const setChecked = (state) => (
  updateObject(state, {
    hasChecked: true,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_PROFILE]: setProfile,
  [actionType.SET_CHECKED]: setChecked,
});

export default reducer;

// SELECTORS
export const getProfile = (state) => (
  state.profile
);

export const isLoggedIn = (state) => (
  state.profile !== null
);

export const hasChecked = (state) => (
  state.hasChecked
);
